import { useEffect } from 'react';

const APP_STORE_URL = 'https://apps.apple.com/us/app/lunarlog-ai-trading-journal/id6755897013';

// This component now redirects to the App Store
const AppleWaitlist = () => {
  useEffect(() => {
    // Redirect to App Store
    window.location.href = APP_STORE_URL;
  }, []);

  // Fallback content while redirecting
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0a0a0f',
      color: 'white',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <p style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>Redirecting to the App Store...</p>
      <a 
        href={APP_STORE_URL}
        style={{
          color: '#00d4ff',
          textDecoration: 'none',
          fontSize: '1rem'
        }}
      >
        Click here if not redirected automatically
      </a>
    </div>
  );
};

export default AppleWaitlist;
